/**
 * Singapore dollar.
 */
export var SGD = {
  code: 'SGD',
  base: 10,
  exponent: 2
};